import React from 'react';

export const SHIFTS_TOOLTIP_TITLE = (
  <div style={{ maxWidth: 200, whiteSpace: 'normal' }}>
   Number of shifts with identified Individuals out of all possible shifts in the period.
  </div>
);

export const INBOUND_PERFORMANCE_TOOLTIP_TITLE = (
  <div style={{ maxWidth: 250, whiteSpace: 'normal' }}>
    <div>
      Inbound Manual Work Segment count by overall speed: FAST, NORMAL, and SLOW.
    </div>
    <div style={{ marginTop: 8 }}>
      NOT MEASURED are Machine unloads and inbound processes missing cargo information.
    </div>
  </div>
);
